module.exports = __webpack_public_path__ + "static/media/txaq.c9daa5e2.png";